import React, { SyntheticEvent } from 'react';
import cn from 'classnames';
import Text from '../text/text';

import './remove-entity-button.scss';

interface IRemoveEntityButtonProps {
    onClick: () => void;
    disabled?: boolean;
    buttonText?: string;
    buttonTextId?: string;
    classname?: string;
}

const RemoveEntityButton = ({
    onClick,
    classname,
    disabled = false,
    buttonText = 'Delete',
    buttonTextId = 'oe.common.delete',
}: IRemoveEntityButtonProps) => {

    const handleClick = (e: SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
    };

    return (
        <div
            className={cn('remove-entity--wrapper', {
                [classname]: !!classname,
            })}
        >
            <button
                className={cn('remove-entity--button', {
                    'remove-entity--button-disabled': disabled,
                })}
                onClick={disabled ? undefined : handleClick}
                disabled={disabled}
            >
                <Text
                    id={buttonTextId}
                    message={buttonText}
                    description='Button label'
                />
            </button>


        </div>
    );
};

export default RemoveEntityButton;